import React, { useContext, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Formik, Form, ErrorMessage } from "formik";
import Cookies from "js-cookie";
import * as Yup from "yup";
import { ProfileSection } from "../context/ProfileContext";
import { setNewSupport } from "../api";
import { Alert } from "./";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiMessageSquare, FiSend, FiArrowLeft, FiList, FiCheckCircle, FiClock } from "react-icons/fi";

const ContactUsComp = (props) => {
  const { t } = useTranslation();
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const supportTypeList = useSelector((state) => state.supportTypeList);
  const supportMine = useSelector((state) => state.supportMine);
  const token = Cookies.get("token");
  const form = useRef();
  const initialContactUsValues = {
    type: "",
    body: "",
  };
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitContactUsForm = () => {
    const data = new FormData(form.current);
    setNewSupport(data, token)
      .then(() => {
        form.current.reset();
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("درخواست شما با موفقیت ارسال شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 3000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchemaContactUs = Yup.object({
    type: Yup.string().required(t("یک گزینه را انتخاب کنید")),
    body: Yup.string().required(t("توضیحات را وارد کنید.")),
  });

  // Function to get status color
  const getStatusColor = (status) => {
    if (status === "answered" || status === "پاسخ داده شده") {
      return "#00c853";
    }
    if (status === "pending" || status === "در انتظار") {
      return "#ff9800";
    }
    return "#f56565";
  };

  // Function to get status text
  const getStatusText = (status) => {
    if (status === "answered") return t("پاسخ داده شده");
    if (status === "pending") return t("در انتظار");
    return status;
  };

  return (
    <div className="setting-container" style={{ minHeight: "90vh" }}>
      <h2 className="setting-title">{t("پشتیبانی")}</h2>

      {/* Form Section */}
      <Formik
        initialValues={initialContactUsValues}
        onSubmit={submitContactUsForm}
        validationSchema={validationSchemaContactUs}
      >
        {(formProps) => (
          <Form ref={form}>
            {/* Support Type Dropdown */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiList size={18} />
                <span>{t("نوع درخواست")}</span>
              </div>
              <select
                className="setting-select"
                name="type"
                value={formProps.values.type}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
              >
                <option value="" label={t("یک گزینه را انتخاب کنید")} />
                {supportTypeList?.map((type, index) => (
                  <option value={type.id} label={type.caption} key={index} />
                ))}
              </select>
              <ErrorMessage name="type">
                {(errMsg) => (
                  <div className="setting-error">{errMsg}</div>
                )}
              </ErrorMessage>
            </div>

            {/* Message Body */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiMessageSquare size={18} />
                <span>{t("توضیحات")}</span>
              </div>
              <textarea
                rows="5"
                placeholder={t("توضیحات خود را وارد کنید")}
                name="body"
                className="setting-textarea"
                value={formProps.values.body}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
              />
              <ErrorMessage name="body">
                {(errMsg) => (
                  <div className="setting-error">{errMsg}</div>
                )}
              </ErrorMessage>
            </div>

            {/* Submit Button */}
            <div className="setting-buttons">
              <button
                type="button"
                className="setting-back-btn"
                onClick={() => ProfileShowHideFunc("setting")}
                style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
              >
                <FiArrowLeft size={18} />
                <span>{t("بازگشت")}</span>
              </button>
              <button type="submit" className="setting-back-btn">
                <FiSend size={18} />
                <span>{t("ارسال")}</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {/* Tickets History */}
      {supportMine?.length > 0 && (
        <div className="tickets-section">
          <h3 className="tickets-title">{t("درخواست‌های قبلی")}</h3>
          <div className="tickets-list">
            {supportMine?.map((ticket, index) => (
              <div className="ticket-item" key={index}>
                <div className="ticket-content">
                  <p className="ticket-text">{ticket.body}</p>
                </div>
                <div className="ticket-status" style={{ backgroundColor: getStatusColor(ticket.status) }}>
                  <FiCheckCircle size={12} />
                  <span>{getStatusText(ticket.status)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const ContactUs = withRouter(ContactUsComp);

export { ContactUs };